import React, { useEffect } from 'react';
import { node, string } from 'prop-types';
import { extend, useDataModel } from '@thd-nucleus/data-sources';
import { StoreLayout } from '@thd-olt-component-react/store-layout';
import { StorePod } from '@thd-olt-component-react/store-pod';
import { StoreHeroContext } from './StoreHero.context';
import { StoreHeroDropdown } from './modules/store-hero-dropdown/StoreHeroDropdown';

const StoreHero = ({
  children, storeId
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('store-hero.ready'); }, []);

  const options = {
    variables: {
      storeSearchInput: storeId,
      pagesize: '1'
    }
  };

  const { data, loading } = useDataModel('storeSearch', options);
  const store = data?.storeSearch?.stores?.[0];
  const contextValue = {
    loading,
    store: {
      ...store,
      storeId: Number(storeId).toString()
    }
  };

  return (
    <StoreHeroContext.Provider value={contextValue}>
      <div data-component="StoreHero">
        {children}
      </div>
    </StoreHeroContext.Provider>
  );
};

StoreHero.propTypes = {
  storeId: string.isRequired,
  children: node.isRequired
};

StoreHero.defaultProps = {};

StoreHero.displayName = 'StoreHero';

StoreHero.dataModel = extend({},
  StoreLayout,
  StorePod,
  StoreHeroDropdown
);

export { StoreHero };
